import { JButton } from '@atoms/JButton';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import JTextFieldBase from '@atoms/JTextFieldBase';
import { isValueInEnum } from '@/lib/enumUtils';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { IconSize } from '@constants';
import AcceptanceCvVideoDto from '@cv-videos/models/dto/acceptance-cv-video-dto';
import CvVideoRejectionReason from '@cv-videos/models/cv-video-rejections-reasons';
import CvVideoStatus from '@cv-videos/models/cv-video-status';

interface CvVideoRejectionDialogBodyProps {
  onClose: () => void;
  onConfirm: (value: AcceptanceCvVideoDto) => void;

  candidateName: string;
}
const CvVideoRejectionDialogBody = ({
  onClose,
  candidateName,
  onConfirm,
}: CvVideoRejectionDialogBodyProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [selectedReason, setSelectedReason] = useState<
    CvVideoRejectionReason | undefined
  >();
  const [reasonText, setReasontext] = useState<string | undefined>();
  return (
    <FormControl>
      <Typography>
        Êtes-vous sûr de vouloir rejeter le CV Vidéo de{' '}
        <Typography variant="h4" display={'inline-block'}>
          {candidateName}
        </Typography>
        ?
      </Typography>

      <Stack gap={1} my={2}>
        <RadioGroup
          data-qa="reason-radio-group"
          onChange={(e) => {
            if (isValueInEnum(CvVideoRejectionReason, e.target.value))
              setSelectedReason(e.target.value as CvVideoRejectionReason);
          }}
        >
          {Object.values(CvVideoRejectionReason).map((reason, index) => (
            <FormControlLabel
              data-qa={`reason-option-${index}`}
              key={reason}
              value={reason}
              control={
                <Radio
                  color="secondary"
                  checkedIcon={
                    <CheckCircleIcon
                      height={IconSize.md}
                      color={theme.palette.secondary.main}
                    />
                  }
                />
              }
              label={t(`${reason.toUpperCase()}_VIDEO`)}
            />
          ))}
        </RadioGroup>
        <JTextFieldBase
          data-qa="reason-field"
          required
          onChange={(e) => setReasontext(e.target.value)}
          multiline
          fullWidth
          label="Décrivez la raison de votre rejet"
          rows={4}
        />
      </Stack>
      <Stack direction={'row'} gap={1}>
        <JButton
          data-qa="reject-button"
          onClick={() => {
            if (!selectedReason || !reasonText) return;
            onConfirm({
              status: CvVideoStatus.REJECTED,
              createCvVideoRejectionDto: {
                reason: selectedReason,
                comment: reasonText,
              },
            });
          }}
          disabled={!selectedReason || !reasonText?.replace(/\s/g, '')}
          variant="contained"
          color="error"
          fullWidth
        >
          {t('REJECT')}
        </JButton>
        <JButton
          data-qa="close-button-on-rejection-dialog"
          onClick={onClose}
          variant="contained"
          color="info"
        >
          {t('CANCEL')}
        </JButton>
      </Stack>
    </FormControl>
  );
};

export default CvVideoRejectionDialogBody;
